import React from 'react'
import { Trades } from '@paramount-prestart/shared'

export const TradeBadges = ({ trades, otherTrade }) => {
  const tradeBadges = trades?.map((t) => ({ key: t, label: Trades.tradeLabel(t) })) ?? []
  const otherTradeBadge = otherTrade ? [{ key: `other-${otherTrade}`, label: otherTrade }] : []

  return [...tradeBadges, ...otherTradeBadge].map((trade) => (
    <span key={trade.key} className="trade-badge">
      {trade.label}
    </span>
  ))
}
